export const priceRangeMinMax = 'pricerange-minmax';
export const sortBy = 'order';
export const FILTER_TYPES = {
    size: 'size',
    sortBy: 'order',
    brand: 'brand',
    gender: 'gender',
    age: 'age',
    productSeries: 'tag-productseries',
    material: 'tag-material',
    pattern: 'tag-pattern',
    madeWithCareBoozt: 'tag-mwctoggle',
    madeWithCareBooztlet: 'tag-mwctogglefilter'
};

export const MWC_FILTER_TYPES = [FILTER_TYPES.madeWithCareBoozt, FILTER_TYPES.madeWithCareBooztlet];
